import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../authentication/services/auth.guard.service';
import { ConfigurationFilterComponent } from './components/scripts/configurationFilter.component';
import { ConfigurationComponent } from './components/scripts/configuration.component';


const configurationRoutes: Routes = [
 {
    path: 'configuration', component: ConfigurationFilterComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['ConfigurationManager']
    },
    children: [
      {
        path: '',
        children: [
          {
            path: 'filter',
            component: ConfigurationFilterComponent,
            data: { preload: true }
          }
        ]
      }
    ]
  },
  {
    path: 'configuration/create',
    component: ConfigurationComponent,
    data: {
      roles: ['ConfigurationManager']
    },
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(configurationRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class ConfigurationRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/configuration/configuration-routing.module.ts